import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListaDTO } from '../models/listaDTO';
import { TipoTramiteDTO } from '../models/tipoTramiteDTO';
import {
  DatosBasicosApoderadoDTO,
  DatosBasicosApoderadoPJDTO,
} from '../models/datosBasicosApoderadoDTO';
import { UbicacionApoderadoDTO } from '../models/ubicacionApoderadoDTO';
import { ContactoApoderadoDTO } from '../models/contactoApoderadoDTO';
import {
  DatosBasicosDemandanteCreadoDTO,
  DatosBasicosDemandanteCreadoPJDTO,
  DatosBasicosDemandanteNuevoDTO,
  DatosBasicosDemandanteNuevoPJDTO,
} from '../models/datosBasicosDemandanteDTO';
import {
  UbicacionDemandanteDTO,
  UbicacionDemandantePJDTO,
} from '../models/ubicacionDemandanteDTO';
import { ContactoDemandanteDTO } from '../models/contactoDemandanteDTO';
import { RespuestaApoderadoDTO } from '../models/respuestaApoderadoDTO';
import { RespuestaDemandanteDTO } from '../models/respuestaDemandanteDTO';
import { CasoDTO } from '../models/casoDTO';
import { RespuestaCasoDTO } from '../models/respuestaCasoDTO';
import { PersonaDTO } from '../models/personaDTO';
import { DatosFinalesDTO } from '../models/datosFinalesDTO';
import { RespuestaDatosFinalesDTO } from '../models/respuestaDatosFinalesDTO';
import { environment } from '../../../../../environments/environment';
import { TramiteSupersaludDTO } from '../models/tramiteSupersaludDTO';

@Injectable({
  providedIn: 'root',
})
export class DemandaService {
  private apiUrl = `${environment.apiUrl}/lista`;
  private guardarUrl = `${environment.apiUrl}/supersalud/tramite/cobertura-servicios/crear`;
  private personaUrl = `${environment.apiUrl}/persona/obtenerPorTipoYNumDocumento`;
  constructor(private http: HttpClient) {}

  // Servicio que obtiene las listas por nombre
  listasValor(nombre: string) {
    return this.http.get<ListaDTO[]>(`${this.apiUrl}/listaValor/${nombre}`);
  }

  // Servicio que obtiene los tipos de trámite de acuerdo con el ID de la entidad
  listasTipoTramite(idEntidad: number) {
    return this.http.get<TipoTramiteDTO[]>(
      `${this.apiUrl}/tipotramite/${idEntidad}`
    );
  }

  // Servicio para guardar el trámite
  guardarTramite(datos: TramiteSupersaludDTO) {
    return this.http.post<any>(`${this.guardarUrl}`, datos);
  }
  // Servicio que guarda los datos básicos del apoderado
  guardarDatosBasicosApoderado(
    datos: DatosBasicosApoderadoDTO | DatosBasicosApoderadoPJDTO
  ) {
    return this.http.post<RespuestaApoderadoDTO>(`${this.guardarUrl}`, datos);
  }

  // Servicio que guarda la ubicación del apoderado
  guardarUbicacionApoderado(datos: UbicacionApoderadoDTO) {
    return this.http.post<RespuestaApoderadoDTO>(`${this.guardarUrl}`, datos);
  }

  // Servicio que guarda los datos de contacto del apoderado
  guardarContactoApoderado(datos: ContactoApoderadoDTO) {
    return this.http.post<RespuestaApoderadoDTO>(`${this.guardarUrl}`, datos);
  }

  // Servicio que guarda los datos básicos del demandante
  guardarDatosBasicosDemandante(
    datos:
      | DatosBasicosDemandanteCreadoDTO
      | DatosBasicosDemandanteNuevoDTO
      | DatosBasicosDemandanteCreadoPJDTO
      | DatosBasicosDemandanteNuevoPJDTO
  ) {
    return this.http.post<RespuestaDemandanteDTO>(`${this.guardarUrl}`, datos);
  }

  // Servicio que guarda la ubicación del demandante
  guardarUbicacionDemandante(
    datos: UbicacionDemandanteDTO | UbicacionDemandantePJDTO
  ) {
    return this.http.post<RespuestaDemandanteDTO>(`${this.guardarUrl}`, datos);
  }

  // Servicio que guarda los datos de contacto del demandante
  guardarContactoDemandante(datos: ContactoDemandanteDTO) {
    return this.http.post<RespuestaDemandanteDTO>(`${this.guardarUrl}`, datos);
  }

  // Servicio que guarda los datos del caso
  guardarCaso(datos: CasoDTO) {
    return this.http.post<RespuestaCasoDTO>(`${this.guardarUrl}`, datos);
  }

  // Servicio que guarda la parte final del formulario
  guardarDatosFinales(datos: DatosFinalesDTO) {
    return this.http.post<RespuestaDatosFinalesDTO>(
      `${this.guardarUrl}`,
      datos
    );
  }

  // Servicio que verifica si el apoderado ya se encuentra registrado
  verificarPersona(tipo: number, numero: string) {
    return this.http.get<PersonaDTO>(`${this.personaUrl}/${tipo}/${numero}`);
  }
}
